import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FavoriteTeaserProduct from 'components/molecules/Favorite/TeaserProduct';
import appConfig from 'helper/mapBackendConfig';
import { actionCreators as programItemsAC } from 'store/programItems';

const mapStateToProps = (state, ownProps: any) => ({
	...ownProps,
	disableRetailerContext: (appConfig.views.Favorites as any).disableRetailerContext,
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doToggleFavorite: programItemsAC.doToggleFavorite,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteTeaserProduct as any);
